/*
 * DRIVLY-UI React Components
 * @license MIT
 */
function e(e,t){let a=e(),r=new Set;return{getSnapshot:()=>a,subscribe:e=>(r.add(e),()=>r.delete(e)),dispatch(e,...c){let l=t[e].call(a,...c);l&&(a=l,r.forEach((e=>e())))}}}export{e as createStore};
//# sourceMappingURL=store.js.map
